import { API_URL_STORE } from "./urls"
import { setAuthorizationToken, removeAuthorizationToken } from "@/axios"

// GET requests

const getPaymentAccounts = () => {
  return window.axios
    .get(API_URL_STORE + "user-v1/payment/accounts/v1/get")
    .then(({ data }) => {
      if (data.code === "OC_OK") {
        return data.createdEntity.bills
      }

      throw new Error(data.message)
    })
    .catch((err) => {
      throw err
    })
}

// POST requests

const orderPayBySchoolPaymentApi = (orderNum, billId) => {
  return window.axios
    .post(API_URL_STORE + "user-v1/payment/accounts/v1/create", {
      entityInfo: {
        billId,
        orderNum,
      },
    })
    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.createdEntity
      }
    })
    .catch((err) => {
      throw err
    })
}

const createPaymentIntent = (order, jwt = null) => {
  if (jwt) {
    setAuthorizationToken(jwt)
  }
  return window.axios
    .post(API_URL_STORE + "stripe/checkout/v1/create", order)
    .then(({ data }) => {
      if (jwt) {
        removeAuthorizationToken()
      }
      if (data.responseCode === "OC_OK") {
        return data.responseEntity.checkoutUrl
      }
    })
    .catch((err) => {
      if (jwt) {
        removeAuthorizationToken()
      }
      throw err
    })
}

export { getPaymentAccounts, orderPayBySchoolPaymentApi, createPaymentIntent }
